import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=88ddd60e&"
import script from "./PageLoading.vue?vue&type=script&lang=ts&"
export * from "./PageLoading.vue?vue&type=script&lang=ts&"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=88ddd60e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports